import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { PublicRoute } from './components/PublicRoute';
import { ProtectedRoute } from './components/ProtectedRoute';
import { HealthCoachDashboard } from './components/HealthCoachDashboard/HealthCoachDashboard';
import { useModal } from './hooks/useModal';
import { UserDetailsRoute } from './components/UserDashboard/UserDetailsRoute';
import { LandingPage } from './components/LandingPage/LandingPage';
import { AppLayout } from './AppLayout';
import { NotFoundPage } from './components/NotFoundView/NotFoundPage';
import { SupportPage } from './components/SupportPage/SupportPage';
import { ProviderHome } from './components/ProviderHome/ProviderHome';
export const Root = () => {
  const modalToRender = useModal();

  return (
    <>
      {modalToRender}

      <Router>
        <AppLayout>
          <Routes>
            <Route
              path="/"
              element={
                <PublicRoute>
                  <LandingPage />
                </PublicRoute>
              }
            />

            <Route
              path="/hc-dashboard"
              element={
                <ProtectedRoute>
                  <HealthCoachDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/support"
              element={
                <ProtectedRoute>
                  <SupportPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/tasks"
              element={
                <ProtectedRoute>
                  <ProviderHome />
                </ProtectedRoute>
              }
            />

            <Route
              path="/user-details/:patient/*"
              element={
                <ProtectedRoute>
                  <UserDetailsRoute />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </AppLayout>
      </Router>
    </>
  );
};
